import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate} from "react-intl";

StartDate.propTypes = {
    date: PropTypes.string
};

function StartDate({date}) {
    return (
        <FormattedDate
            value={new Date(date)}
            year={"numeric"}
            month={"numeric"}
            day={"numeric"}
            hour={"numeric"}
            minute={"numeric"}
            second={"numeric"}
        />
    );
}

export default StartDate;
